import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import {
  formatEventStartShort,
  formatShortAddress,
  getStartDateFormatter,
  sort,
  timezones,
} from './../../../../utilities/helpers'

import Card from 'react-bootstrap/Card'
import Row from 'react-bootstrap/Row'

import './venueCardBody.scss'

export default function VenueCardBody({ venue }) {
  let timezone = timezones(venue?.timezone)
  const organizationSlug = venue?.allEvents?.[0]?.organization?.slug

  return (
    <Fragment>
      <Card.Title as="h5">{venue?.name}</Card.Title>
      <Card.Text as="p">{formatShortAddress(venue)}</Card.Text>
      <hr />
      <ul className="venue-list">
        {venue &&
          venue.allEvents &&
          sort(venue.allEvents).map((event, index) => {
            return (
              <li key={index}>
                <Row>
                  <span className="col caption">
                    {formatEventStartShort(
                      event,
                      timezone,
                      getStartDateFormatter(event)
                    )}
                  </span>
                  <span className="col caption caption-bold text-end">
                    {event?.name}
                  </span>
                </Row>
              </li>
            )
          })}
      </ul>
      <Card.Link
        as={Link}
        to={organizationSlug ? `/${organizationSlug}` : `/venue/${venue?.slug}`}
        className="btn btn-outline-light text-primary btn-sm"
      >
        View All
      </Card.Link>
    </Fragment>
  )
}
